import React, { type ReactNode, useState } from 'react';

import { Button } from '../common/Button';
import { Tooltip } from '../tooltips';
import { View } from '../common/View';

type ActionButtonProps = {
  icon: ReactNode;
  label: string;
  showLabel: boolean;
  adoptionId?: string;
  onClick: () => void;
};

export function ActionButton({
  adoptionId,
  icon,
  label,
  showLabel,
  onClick,
}: ActionButtonProps) {
  const [isMouseOver, setIsMouseOver] = useState(false);

  return (
    <Button
      data-adoption-id={adoptionId}
      onClick={onClick}
      onMouseEnter={() => setIsMouseOver(true)}
      onMouseLeave={() => setIsMouseOver(false)}
    >
      {icon} {showLabel && label}
      {!showLabel && isMouseOver && (
        <Tooltip
          position="bottom-right"
          style={{ padding: 0 }}
          onClose={() => setIsMouseOver(false)}
        >
          <View style={{ padding: 12 }}>
            {label}
          </View>
        </Tooltip>
      )}
    </Button>
  );
}
